export const GET_ALL_TOKENS = 'GET_ALL_TOKENS'
